import fetch, { notStandardAjax, BaseResponse } from './fetch';
import { AuthType, RoleListType, SetRoleType } from '../type/auth';

/**
 * 获取菜单权限
 * @returns ResMenu
 */

export async function getMenuAuthority(): Promise<BaseResponse<AuthType>> {
  const { data } = await notStandardAjax.get<BaseResponse<AuthType>>('/haichuan/api/getUserMenuPerm', {});
  return data;
}

/**
 * 获取角色列表
 * @returns RoleListType
 */
export async function getRoleList(): Promise<BaseResponse<RoleListType>> {
  const { data } = await notStandardAjax.get<BaseResponse<RoleListType>>('/haichuan/api/teacherRoleList', {});
  return data;
}

/**
 * 设置角色
 */
export async function setRole(params: SetRoleType): Promise<BaseResponse> {
  const { data } = await fetch.post<BaseResponse>('/haichuan/api/addTeacherIdAndRole', params);
  return data;
}

/**
 * 根据工号获取班主任教师id
 */
export async function getTeacherHasId(params?: { teacher_id: string; workcode?: string }): Promise<BaseResponse<RoleListType>> {
  const { data } = await notStandardAjax.get<BaseResponse<RoleListType>>('/haichuan/api/getTeacherHasId', params);
  return data;
}
